// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LaborRateList from './state-connector';

const LaborRate = props =>
    props.children || <LaborRateList {...props}/>;

LaborRate.propTypes = {
    children: PropTypes.node
};

export default LaborRate;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/index.js